import { useCallback, useEffect, useState } from 'react'
import { ButtonCloseModal, ModalFullCentered } from '../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import twinFetchPost from '../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import LoadingSpinner from '../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import './modalPreviewPdfBuy.sass'

type ModalPreviewPdfBuyProps = ModalPreviewPdfBuyLogicProps & ModalEditComponentProps & {}

const ModalPreviewPdfBuy: React.FC<ModalPreviewPdfBuyProps> = ({ setOpened, Order, PdfTemplateId, urlGetPdf }) => {
    const { pdfCode } = useModalPreviewPdfBuyLogic({ Order, PdfTemplateId, urlGetPdf })
    return (
        <ModalFullCentered className='flex flex-col modal_preview_pdf_buy' opened={true} setOpened={setOpened}>
            <ButtonCloseModal setOpened={setOpened} />
            {pdfCode ? <object data={pdfCode} type="application/pdf" width="100%" height="100%" aria-label='pdf' className='preview_pdf'></object> : <LoadingSpinner />}
        </ModalFullCentered>
    )
}

interface ModalPreviewPdfBuyLogicProps {
    Order: TwinDictionary
    PdfTemplateId: number
    urlGetPdf: string
}

const useModalPreviewPdfBuyLogic = ({ Order, PdfTemplateId, urlGetPdf }: ModalPreviewPdfBuyLogicProps) => {
    const [pdfCode, setPdfCode] = useState<string | null>(null)
    const getPdfTemplate = useCallback(async () => {
        const result = await twinFetchPost(urlGetPdf, { id: Order.id, PdfTemplateId })
        if (result) {
            const pdf = await result.blob()
            const fileURL = URL.createObjectURL(pdf)
            setPdfCode(fileURL)
        }
    }, [Order, setPdfCode, PdfTemplateId, urlGetPdf])

    useEffect(() => {
        getPdfTemplate()
    }, [getPdfTemplate])
    return { pdfCode }
}

type ModalPreviewPdfBuyGetProps = ModalEditComponentProps & {
    urlGetPdf: string
}


export const ModalPreviewPdfBuyGet: React.FC<ModalPreviewPdfBuyGetProps> = ({ setOpened, urlGetPdf }) => {
    return (
        <ModalFullCentered className='flex flex-col modal_preview_pdf_buy' opened={true} setOpened={setOpened}>
            <ButtonCloseModal setOpened={setOpened} />
            <object data={urlGetPdf} type="application/pdf" width="100%" height="100%" aria-label='pdf' className='preview_pdf'></object>
        </ModalFullCentered>
    )
}

export default ModalPreviewPdfBuy